import axios from 'axios'
import apiURI from './Api';

export default class SubcategoriesService {
   async getSubcategories(token) {
    const response = await axios({ method: 'get', url: `${apiURI}/product/category/subcategories/all`, headers: { 'Authorization': 'Bearer ' + token } });
    return response.data;
  }

   async postUploadImage(token, image) {
    let data = new FormData();
    data.append('image', image);

    const response = await axios({
      method: 'post', url: `${apiURI}/upload/uploadimage`, data: data,
      headers: { 'Authorization': 'Bearer ' + token }
    }).catch(e => console.log(e));

    return response.data
  }

  async postRegisterSubcategory(token, descriptionEnglish, descriptionItalian, descriptionPortugues, descriptionSpanish, idcategory, imageid, service) {
    
    const bodyJson = {
      descriptionEnglish,
      descriptionItalian,
      descriptionPortugues,
      descriptionSpanish,
      idcategory,
      imageid,
      service,
    }

    const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/subcategories/register`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async postEditSubcategory(token, descriptionEnglish, descriptionItalian, descriptionPortugues, descriptionSpanish, idcategory, idsubcategory, imageid, service) {
    
    const bodyJson = {
      descriptionEnglish,
      descriptionItalian,
      descriptionPortugues,
      descriptionSpanish,
      idcategory,
      idsubcategory,
      imageid,
      service,
    }
    
    const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/subcategories/edit`,
      headers: { 'Authorization': 'Bearer ' + token }
    });
    console.log('response: ', response)

    return response.data;
  }

  async getCategoryById(categoryId) {
    const response = await axios({
    method: 'get', url: `${apiURI}/product/category/getbyid/${categoryId}`
  });

    return response.data;
  }

  async postLinkBrandSubcategory(token, idbrand, idsubcategory) {
    const bodyJson = {
      idbrand,
      idsubcategory,
   }

      const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/subcategories/linkbrand`, 
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async postLinkTypeSubcategory(token, idtype, idsubcategory) {
    const bodyJson = {
      idtype,
      idsubcategory,
   }

      const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/subcategories/linktype`, 
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  //   async getSubcategories(subCategoryId) {
//     const response = await axios.get(`${apiURI}/product/category/subcategories/getbyidcategory/${subCategoryId}`)
//     return response.data;
//   }

//   async getAttributes(token, username) {
//     const response = await axios({ method: 'get', url: `${apiURI}/attribute/getbyuser/${username}`, headers: { 'Authorization': 'Bearer ' + token } });
//     return response.data;
//   }

//    async postAttributeRegister(token, attribute, username) {
//     const bodyJson = {
//       attribute: attribute,
//       username: username
//     }

//     const response = await axios({
//       method: 'post', url: `${apiURI}/attribute/register`, data: bodyJson,
//       headers: { 'Authorization': 'Bearer ' + token }
//     });

//     return response.data;
//   }

//   async postRegisterAttributeValue(token, attributeId, attributeValue, username) {
//     const bodyJson = {
//       attributevalue: attributeValue,
//       idattribute: attributeId,
//       username: username
//     }

//     const response = await axios({
//       method: 'post', url: `${apiURI}/attribute/value/register`, data: bodyJson,
//       headers: { 'Authorization': 'Bearer ' + token }
//     });

//     return response.data;
//   }

}